import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useRouter } from '@tribeplatform/react-sdk';
import { Dropdown, } from '@tribeplatform/react-ui-kit/Dropdown';
export const ActionItem = ({ action, hotkey, icon: Icon, name, url, disabled, isShortcut, }) => {
    const { Link } = useRouter();
    const handleClick = e => {
        if (isShortcut) {
            e.preventDefault();
        }
        action === null || action === void 0 ? void 0 : action();
    };
    const icon = React.isValidElement(Icon) ? Icon : _jsx(Icon, {}, void 0);
    if (action) {
        return (_jsx(Dropdown.Item, { onClick: handleClick, hotkey: hotkey, disabled: disabled, leadingIcon: icon, children: name }, void 0));
    }
    return (_jsx(Dropdown.Item, { as: Link, href: url, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        variant: "inherit", hotkey: hotkey, disabled: disabled, onClick: handleClick, leadingIcon: icon, children: name }, void 0));
};
//# sourceMappingURL=ActionItem.js.map